import { configureStore } from "@reduxjs/toolkit";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers";
import { loadData } from "../connection";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      composeWithDevTools,
      thunk: {
        extraArgument: {
          api: {
            loadData,
          },
        },
      },
    }),
});

export default store;
